import { HttpClient } from '@angular/common/http';
import { Component, input, output, OnInit, inject } from '@angular/core';

import { environment } from '@environments';

@Component({
  selector: 'app-tva-img',
  template: `
    <img
      [class]="imgClass()"
      [src]="imageSrc"
      [alt]="''"
      (load)="imageLoaded.emit()"
      (error)="imageLoadError.emit()"
    />
  `,
})
export class TvaImageComponent implements OnInit {
  private httpClient = inject(HttpClient);

  image_id = input.required<string>();
  alt = input<string>();
  imgClass = input<string>();
  imageLoaded = output<void>();
  imageLoadError = output<void>();
  imageSrc: string | null = null;

  ngOnInit(): void {
    this.fetchImage();
  }
  private fetchImage(): void {
    const url = `${environment.API_URL}/timesheet/image/${this.image_id()}`;

    this.httpClient.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        this.imageSrc = URL.createObjectURL(blob);
      },
      error: () => {
        this.imageSrc = null;
        this.imageLoadError.emit();
      },
    });
  }
}
